import { useQuery } from "@tanstack/react-query";
import { useGetAll, useGetOne } from "./crudService";

// const service = registerService('user-meta');
// export default service;

const endpoint:string = 'users';

export function useGetAllUsers() {
    return useGetAll({queryKey: [endpoint]});
}

export function useGetUser(id: number, queryParams:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...queryParams});
}
